import { inject, observer } from 'mobx-react';
import styles from './style.m.less';
import AuthStyle from '@/components/Auth/style.m.less';
import { getFormatDate } from '@/utils/utils';
import { filterHtml, decodeHtmlAll } from '@/utils';
import { useEffect } from 'react';
import { Button } from 'antd';

const ForceNoticeModal = (props) => {
    const { forceNotice } = props.store;
    const handleClick = () => {
        let path = `/web/${props.template_id}/${props.business_id}/notice-detail?id=${forceNotice.noticeValue.id}`;
        window.open(path, '_self');
    };
    useEffect(() => {
        forceNotice.getForceNoticeDetail({
            business_id: props.business_id,
            template_id: props.template_id
        });
    }, [props.business_id, props.template_id]);
    return (
        <>
            <div className={AuthStyle.authModalContent}>
                <div className={styles['title']}>{forceNotice.noticeValue.title}</div>
                <div className={styles['time']}>{getFormatDate(forceNotice.noticeValue.publish_time, 'MM-DD')}</div>
                <div className={styles['content']}>{filterHtml(decodeHtmlAll(forceNotice.noticeValue.context))}</div>
            </div>
            <div className={AuthStyle.authModalButton}>
                <Button onClick={handleClick} style={{ width: '262px' }} type="primary">
                    立即查看
                </Button>
            </div>
        </>
    );
};
export default inject('store')(observer(ForceNoticeModal));
